import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
  withProps,
} from '@ngrx/signals';
import {
  addEntity,
  entityConfig,
  setAllEntities,
  updateEntity,
  withEntities,
} from '@ngrx/signals/entities';

import { GridViews } from '@wcg/frontend-framework';
/**
 * Entity Config allows creating an entity store object.
 * {entity: type(DATA_STRUCTURE), collection: string, selectId:(entity) => entity.id}
 * selectId is a function that returns a unique id for each entity collection.
 * */
const _gridViewsEntityConfig = () =>
  entityConfig({
    collection: '_gridViews',
    entity: type<GridViews>(),
    selectId: (entity) => entity.id,
  });

/**
 * withGridViewsEntities is a function that creates a signal store feature
 * for managing the grid_views state slice of DOCUMENTTYPEGRID SIGNAL STORE.
 * It uses the NgRx Signals library to create a reactive store feature.
 * The store feature contains the views of different grid types across the application and provides methods
 * to update the views when new data is available.
 */
export const withGridViewsEntities = () => {
  return signalStoreFeature(
    withProps((store) => ({
      store,
    })),
    withEntities(_gridViewsEntityConfig()),
    withMethods(({ ...store }) => {
      return {
        addGridView: (gridViews: GridViews) =>
          patchState(store, addEntity(gridViews, _gridViewsEntityConfig())),
        setGridViews: (gridViews: GridViews[]) => {
          patchState(
            store,
            setAllEntities(gridViews, _gridViewsEntityConfig()),
          )
            },
        updateGridViews: (gridViews: GridViews) =>
          patchState(
            store,
            updateEntity(
              {
                changes: { ...gridViews },
                id: gridViews.id,
              },
              _gridViewsEntityConfig(),
            ),
          ),
      };
    }),
  );
};
